module.exports = __webpack_public_path__ + "img/avatar2.c9f23e01.jpg";